/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EvidenceRecordDeprecatedErrors
 */
export interface EvidenceRecordDeprecatedErrors {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedErrors
     */
    'detectedDpi'?: EvidenceRecordDeprecatedErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedErrors
     */
    'calculatedDpi'?: EvidenceRecordDeprecatedErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedErrors
     */
    'colorGradation'?: EvidenceRecordDeprecatedErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedErrors
     */
    'heightMillis'?: EvidenceRecordDeprecatedErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedErrors
     */
    'widthMillis'?: EvidenceRecordDeprecatedErrorsWidthMillisEnum;
}

export const EvidenceRecordDeprecatedErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedErrorsDetectedDpiEnum = typeof EvidenceRecordDeprecatedErrorsDetectedDpiEnum[keyof typeof EvidenceRecordDeprecatedErrorsDetectedDpiEnum];
export const EvidenceRecordDeprecatedErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedErrorsCalculatedDpiEnum = typeof EvidenceRecordDeprecatedErrorsCalculatedDpiEnum[keyof typeof EvidenceRecordDeprecatedErrorsCalculatedDpiEnum];
export const EvidenceRecordDeprecatedErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceRecordDeprecatedErrorsColorGradationEnum = typeof EvidenceRecordDeprecatedErrorsColorGradationEnum[keyof typeof EvidenceRecordDeprecatedErrorsColorGradationEnum];
export const EvidenceRecordDeprecatedErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordDeprecatedErrorsHeightMillisEnum = typeof EvidenceRecordDeprecatedErrorsHeightMillisEnum[keyof typeof EvidenceRecordDeprecatedErrorsHeightMillisEnum];
export const EvidenceRecordDeprecatedErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordDeprecatedErrorsWidthMillisEnum = typeof EvidenceRecordDeprecatedErrorsWidthMillisEnum[keyof typeof EvidenceRecordDeprecatedErrorsWidthMillisEnum];


